<template>
	<div>
		<SentimentMarketValue zoom_start="50"></SentimentMarketValue>
		<SentimentMarketTopN zoom_start="50"></SentimentMarketTopN>
	</div>
</template>

<script>
	
	import SentimentMarketValue from 'components/sentiment/SentimentMarketValue.vue'
	import SentimentMarketTopN from 'components/sentiment/SentimentMarketTopN.vue'
		
	export default {
		components: {
			SentimentMarketValue,
			SentimentMarketTopN,
		},
		data() {
			return {
				
			}
		}
	}
</script>

<style scoped>

</style>
